import { ModelBase } from 'store/model-base';

export class CmsPlanSwitch extends ModelBase {
    public static storeName: string = 'cmsPlanSwitch';

    public planSwitchSlider: CmsBucketSwitchCarousal;
    public planSwitchReview: CmsPlanSwitchReview;
    public planSwitchUnlimitedTierUpgradeDowngrade: CmsPlanSwitchUnlimitedTierUpgradeDownGrade;
    public planSwitchUnlimitedTierUpgradeDowngradeForSeg5: CmsPlanSwitchUnlimitedTierUpgradeDownGrade;
    public planSwitchUnlimitedTierUpgradeDowngradeForOtherSeg: CmsPlanSwitchUnlimitedTierUpgradeDownGrade;
    public planSwitchUnlimitedTiersReview: CmsPlanSwitchUnlimitedTiersReview;
    public planSwitchUnlimitedTiersReviewForSeg5: CmsPlanSwitchUnlimitedTiersReview;
    public planSwitchUnlimitedTiersReviewForOtherSegs: CmsPlanSwitchUnlimitedTiersReview;
    public planSwitchUnlimitedTabletTierUpgradeDowngrade: CmsPlanSwitchUnlimitedTierUpgradeDownGrade;
    public planSwitchUnlimitedTabletTiersReview: CmsPlanSwitchUnlimitedTiersReview;
    public cbmPlanSwitchUnlimitedTierUpgradeDowngrade: CmsPlanSwitchUnlimitedTierUpgradeDownGrade;
    public cbmPlanSwitchUnlimitedTierUpgradeDowngradeForSeg5: CmsPlanSwitchUnlimitedTierUpgradeDownGrade;
    public cbmPlanSwitchUnlimitedTierUpgradeDowngradeForSeg5Tablet: CmsPlanSwitchUnlimitedTierUpgradeDownGrade;
    public cbmPlanSwitchUnlimitedTiersReview: CmsPlanSwitchUnlimitedTiersReview;
    public cbmPlanSwitchUnlimitedTiersReviewForSeg5: CmsPlanSwitchUnlimitedTiersReview;
    public cbmPlanSwitchUnlimitedTiersReviewForSeg5IntroToPremium: CmsPlanSwitchUnlimitedTiersReview;
    public cbmPlanSwitchUnlimitedTiersReviewSeg5TabletIntroToPremium: CmsPlanSwitchUnlimitedTiersReview;
    public cbmPlanSwitchUnlimitedTiersReviewSeg5TabletPremiumToIntro: CmsPlanSwitchUnlimitedTiersReview;
    public cbmPlanSwitchUnlimitedTiersReviewForSeg5PremiumToIntro: CmsPlanSwitchUnlimitedTiersReview;
    public cbmPlanSwitchUnlimitedTabletTierUpgradeDowngrade: CmsPlanSwitchUnlimitedTierUpgradeDownGrade;
    public cbmPlanSwitchUnlimitedTabletTiersReview: CmsPlanSwitchUnlimitedTiersReview;
    public planSwitchUnlimitedIntroUpgrade: CmsPlanSwitchUnlimitedIntroUpgrade;
    public planSwitchUnlimitedIntroUpgradeForSeg5: CmsPlanSwitchUnlimitedIntroUpgrade;
    public planSwitchUnlimitedIntroUpgradeForOtherSeg: CmsPlanSwitchUnlimitedIntroUpgrade;
    public planSwitchUnlimitedPlusUpgradeDowngrade: CmsPlanSwitchUnlimitedPlusUpgradeDowngrade;
    public planSwitchUnlimitedPlusUpgradeDowngradeForSeg5: CmsPlanSwitchUnlimitedPlusUpgradeDowngrade;
    public planSwitchUnlimitedPlusUpgradeDowngradeForOtherSeg: CmsPlanSwitchUnlimitedPlusUpgradeDowngrade;
    public planSwitchUnlimitedPremiumDowngrade: CmsPlanSwitchUnlimitedPremiumDowngrade;
    public planSwitchUnlimitedCbmPremiumDowngrade: CmsPlanSwitchUnlimitedPremiumDowngrade;
    public planSwitchUnlimitedPremiumDowngradeForOtherSeg: CmsPlanSwitchUnlimitedPremiumDowngrade;
    public requestSwitch: CmsPlanSwitchData;
    public switchPending: CmsPlanSwitchData;
    public scheduledSwitchInProgress: CmsPlanSwitchData;
    public btgScheduledSwitch: CmsPlanSwitchData;
    public btgScheduledSwitchPlanSeven: CmsPlanSwitchData;
    public success: CmsPlanSwitchData;
    public successSeg5UnlPlusUpgrade: CmsPlanSwitchData;
    public successUnlPremiumFlexUpgrade: CmsPlanSwitchData;
    public successSelectToPlus: CmsPlanSwitchData;
    public successStandardToProUpgrade: CmsPlanSwitchData;
    public failure: CmsPlanSwitchData;
    public ineligibleOveragePlanData: CmsIneligibleOveragePlanData;
    public envelopeIcon: CmsMediaImage;
    public checkIcon: CmsMediaImage;
    public failureIcon: CmsMediaImage;
    public planSwitchMultiplePromotions: CmsPlanSwitchMultiplePromotions;
    public alertIcon: CmsMediaImage;
    public dollarIcon: CmsMediaImage;
    public infoIconGrey: CmsMediaImage;
    public seg5BtgToUnlSwitchBanner: CmsSeg5BtgToUnlSwitchBanner;
    public planSevenUnlPlanSwitchCta: string;
    public reviewDetails: string;
    public expandIcon: CmsMediaImage;
}
